function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 109,
  r: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M508.385,480.531l-49-70C455.642,405.184,449.526,402,443,402h-80V220c0-13.785,11.215-25,25-25 c13.785,0,25,11.215,25,25v103c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V194h39c11.046,0,20-8.954,20-20v-54 c0-8.036-4.81-15.292-12.211-18.421l-236.5-100c-4.99-2.109-10.62-2.105-15.606,0.012l-235.5,100C4.796,104.728,0,111.975,0,120 v54c0,11.046,8.954,20,20,20h33v216.015c-0.128,0.172-0.261,0.339-0.385,0.516l-49,70c-4.276,6.109-4.799,14.091-1.355,20.706 C5.704,507.852,12.543,512,20,512h472c7.458,0,14.296-4.149,17.74-10.764C513.184,494.622,512.661,486.64,508.385,480.531z  M40,154v-20.764l215.517-91.515L472,133.258V154H40z M323,220v182h-50V220c0-13.785,11.215-25,25-25 C311.785,195,323,206.215,323,220z M233,220v182h-50V220c0-13.785,11.215-25,25-25C221.785,195,233,206.215,233,220z M143,220 v182H93V220c0-13.785,11.215-25,25-25C131.785,195,143,206.215,143,220z M58.413,472l21-30h353.174l21,30H58.413z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgUniversity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity);
export default __webpack_public_path__ + "static/media/university.691aee79.svg";
export { ForwardRef as ReactComponent };